import * as React from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { connect } from "react-redux";
import { IImageProps } from "@fluentui/react";
import { Image, ImageFit } from "office-ui-fabric-react/lib/Image";
import BoschClub from "../../../assets/pictures/The_Bosch_Club_Visual_NEW-low-q.jpg";
import { IConfirmation } from "../types";
import RbButton, { ButtonSize, ButtonType } from "../../../bosch-react/components/button/RbButton";
import { RootState } from "../../../store/store";
import { confirmDialog } from "../actions";

class ConfirmationDialog extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      clicked: false,
    };
    this.closeDialog = this.closeDialog.bind(this);
  }

  imageProps: IImageProps = {
    src: BoschClub,
    imageFit: ImageFit.cover,
    maximizeFrame: true,
  };

  BoschAds = 
    <>
      <div style={{ width: "100%", height: "20vw" }}>
        <Image {...(this.imageProps as any)} alt="The_Bosch_Club_Visual_NEW" />
      </div>
      <div
        style={{
          width: "60%",
          textAlign: "center",
          margin: "auto auto",
          fontFamily: "BoschFont",
        }}
      >
        <p>
          If you plan to present your thesis results via MS Teams and you are
          open to share your results to everybody at Bosch, feel free to publish
          your presentation session in <strong>The Bosch Club</strong>. So, all
          interested colleagues world-wide can listen to your presentation.
        </p>
        <p>
          All information and the link to{" "}
          <strong>The Bosch Club calendar</strong> you can find at{" "}
          <a href="https://bos.ch/club" target="blank">
            https://bos.ch/club
          </a>
        </p>
      </div>
    </>

  render() {
    let confirm: IConfirmation = this.props.confirm;
    if (confirm.title === "") {
      return null;
    } else {
      let confirmModel: IConfirmation = confirm as IConfirmation;
      return (
        <Dialog
          minWidth={confirmModel.isShowAds ? "70vw" : "50vw"}
          maxWidth={confirmModel.isShowAds ? "70vw" : "50vw"}
          hidden={false}
          isDarkOverlay={true}
          onDismiss={() => this.closeDialog(false)}
          modalProps={{
            isBlocking: true,
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: confirmModel.title,
            subText: confirmModel.content,
          }}
        >
          {confirmModel.isShowAds&&this.BoschAds}
          <DialogFooter>
            <RbButton
              type={ButtonType.Secondary}
              size={ButtonSize.Small}
              disabled={this.state.clicked}
              onClick={() => this.closeDialog(true)}
              label="OK"
            />
            {confirmModel.hideCancelButton === true ? (
              ""
            ) : (
              <RbButton
                type={ButtonType.Secondary}
                size={ButtonSize.Small}
                disabled={this.state.clicked}
                onClick={() => this.closeDialog(false)}
                label="Cancel"
              />
            )}
          </DialogFooter>
        </Dialog>
      );
    }
  }

  closeDialog(confirmed: any) {
    let confirm: IConfirmation = this.props.confirm;
    this.setState({ clicked: true }, () => {
      if (confirmed === true) {
        confirm.closeCallback();
      } else if (confirmed === false && !!confirm.cancelCallback) {
        confirm.cancelCallback();
      }
      this.props.confirmDialog(false);
      this.setState({ clicked: false });
    });
  }
}

const mapStateToProps = (state: RootState) => ({
  confirm: state.util.confirm,
});

export default connect(mapStateToProps, { confirmDialog })(ConfirmationDialog);
